<template>
  <span class="upload-component">
    <span
      class="upload"
      :class="{'no-slot-upload': noSlot, 'upload-error': error}"
      @click="chooseFile"
    >
      <slot/>
      <input
        ref="fileInput"
        name="file"
        class="upload-input"
        type="file"
        @change="handleFileChange"
        accept="image/jpg, image/jpeg, image/png, image/gif"
      >
      <span class="error-tip">{{ error }}</span>
      <div v-if="uploading" class="loading-cover">
        <img :src="loadingGif">
      </div>
      <div class="img" v-if="imgData">
        <img class="img" :src="imgData">
        <span class="remove" @click="handleRemove($event)">
          <img :src="bin">
        </span>
      </div>
    </span>
  </span>
</template>

<script>
import bin from '@/assets/bin.svg'
import loadingGif from '@/assets/loading_circle.gif'
import Message from '@/components/Message'

export default {
  name: 'upload',
  props: [
    'url',
    'action',
    'onSuccess',
    'beforeUpload',
    'error',
    'onRemove',
    'file'
  ],
  data() {
    return {
      bin,
      loadingGif,
      noSlot: false,
      imgUrl: '',
      percentage: 0,
      imgData: this.file || '',
      uploading: false
    }
  },
  beforeMount() {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      this.noSlot = true
    }
    if (this.url) {
      this.imgData = this.url
    }
  },
  mounted() {},
  methods: {
    chooseFile() {
      this.$refs.fileInput.click()
    },

    handleFileChange() {
      let file = this.$refs.fileInput.files[0]
      if (!file) {
        return
      }
      let validate = true
      if (this.beforeUpload) {
        validate = this.beforeUpload(file)
      }

      validate && this.upload(file)
    },

    upload(file) {
      let _this = this
      let formData = new FormData()
      formData.append('file', file)
      let xhr = new XMLHttpRequest()

      xhr.open('POST', this.action)
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          _this.uploading = false
          let res = JSON.parse(xhr.responseText)
          if (res.code === 0) {
            _this.imgData = URL.createObjectURL(file)
          } else {
            Message.error(res.msg || '上传失败')
          }
          _this.onSuccess(res)
        }
      }
      xhr.send(formData)
      _this.uploading = true
    },
    handleRemove(e) {
      e.stopPropagation()

      this.$refs.fileInput.value = ''
      this.imgData = ''
      this.onRemove && this.onRemove()
    }
  },
  watch: {
    file(val) {
      this.imgData = val
    },
    url (val) {
      this.imgData = val
    }
  }
}
</script>

<style scoped lang="scss">
@import 'style.scss';
</style>
